// Code from https://www.pluralsight.com/courses/redux-saga
// https://www.pluralsight.com/authors/daniel-stern the Code Whisperer

export const makeActionCreator = (type: string, ...argNames: string[]) => {
  return function (...args: any[]): any {
    const action = { type }
    argNames.forEach((arg, index) => {
      // @ts-ignore
      action[argNames[index]] = args[index]
    })
    return action
  }
}
